<template>
  <el-container class="login_bg" type="flex" style="height:100%">
    <el-main>
      <el-page-header @back="goBack" content="订单详情">
      </el-page-header>
      <el-card shadow="always">
        <el-row class="consumeOrderInfo">
          <el-col :span="4">
            <i v-if="consumeOrderInfo.orderStatus == 1" class="icon el-icon-document-remove"></i>
            <i v-else-if="consumeOrderInfo.orderStatus == 2" class="icon el-icon-document-checked"></i>
            <i v-else class="icon el-icon-circle-close"></i>
            <div>{{ code.orderStatus[consumeOrderInfo.orderStatus] }}</div>
          </el-col>
          <el-col :span="4">
            <div>订单编号</div>
            <div>{{ consumeOrderInfo.id }}</div>
          </el-col>
          <el-col :span="4">
            <div>下单时间</div>
            <div>{{ consumeOrderInfo.createDt }}</div>
          </el-col>
          <el-col :span="4">
            <div>下单人</div>
            <div>{{ consumeOrderInfo.purchaseBy }}</div>
          </el-col>
          <el-col :span="4">
            <div v-if="consumeOrderInfo.orderStatus == 1">剩余付款时间</div>
            <div v-if="consumeOrderInfo.orderStatus == 2">支付时间</div>
            <div v-if="consumeOrderInfo.orderStatus == 3">支付时间</div>
            <div v-if="consumeOrderInfo.orderStatus == 4">过期时间</div>
            <div v-if="consumeOrderInfo.orderStatus == 5">取消时间</div>
            <div v-if="consumeOrderInfo.orderStatus == 6">退款时间</div>
            <div v-if="consumeOrderInfo.orderStatus == 1">{{ consumeOrderInfo.payRemainingDt }}</div>
            <div v-else-if="consumeOrderInfo.orderStatus == 2">{{ consumeOrderInfo.payDt }}</div>
            <div v-else>{{ consumeOrderInfo.updateDt }}</div>
          </el-col>
          <el-col :span="4">
            <div>应付总额</div>
            <div>{{ consumeOrderInfo.amount }}</div>
          </el-col>
        </el-row>
      </el-card>
      <h3>商品信息</h3>
      <el-row class="product_information">
        <el-col :span="3" class="item">
          <div class="title">软件版本</div>
          <div class="info">{{ packageLogInfo.packageName }}</div>
        </el-col>
        <el-col :span="3" class="item">
          <div class="title">套餐PC账号</div>
          <div class="info">{{ packageLogInfo.pcActNum }}</div>
        </el-col>
        <el-col :span="3" class="item">
          <div class="title">套餐司机账号</div>
          <div class="info">{{ packageLogInfo.driverActNum }}</div>
        </el-col>
        <el-col :span="3" class="item">
          <div class="title">
            <el-badge :value="packageLogInfo.salesActNum" type="warning">
              <div>业务员账号数量</div>
            </el-badge>
          </div>
          <div class="info">{{ packageLogInfo.salesActNum }}</div>
        </el-col>
        <el-col :span="3" class="item">
          <div class="title">
            <el-badge :value="packageLogInfo.incPcActNum" type="warning">
              <div>PC加购账号数</div>
            </el-badge>
          </div>
          <div class="info">{{ packageLogInfo.incPcActNum }}</div>
        </el-col>
        <el-col :span="3" class="item">
          <div class="title">
            <el-badge :value="packageLogInfo.incDriverActNum" type="warning">
              <div>司机加购账号数</div>
            </el-badge>
          </div>
          <div class="info">{{ packageLogInfo.incDriverActNum }}</div>
        </el-col>
        <el-col :span="3" class="item">
          <div class="title">
            <el-badge :value="packageLogInfo.incSalesActNum" type="warning">
              <div>业务员账号加购数</div>
            </el-badge>
          </div>
          <div class="info">{{ packageLogInfo.incSalesActNum }}</div>
        </el-col>
        <el-col :span="3" class="item">
          <div class="title">购买时长</div>
          <div class="info">{{ packageLogInfo.purchaseTime }}</div>
        </el-col>
      </el-row>
    </el-main>

    <div class="footer-copyright">Copyright@2016-2023杭州闪派网络科技有限公司版权所有 网站备案/许可证号：
      <a href="https://beian.miit.gov.cn/" target="“_blank&quot;">浙ICP备16031137号</a>
      <img :src="require('@/assets/images/gongan.png')" alt="" style="vertical-align: middle;margin-left: 10px;"> 浙公网安备案
      <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010502007569"
        target="“_blank&quot;">33010502007569</a>
    </div>
  </el-container>
</template>
<script>
import {
  getPurchaseRecordInfo,
  // submit
} from '@/api.js'
import {
  mapState
} from 'vuex'

export default {
  name: "CompanyPurchaseRecordDetails",
  data() {
    return {
      dialogVisible: false,
      isPay: 1,
      consumeOrderInfo: {},
      packageLogInfo: {},
    }
  },
  created() {
    this.getPurchaseRecordInfo()
  },
  mounted() {

  },
  methods: {
    goBack() {
      this.$router.back()
    },
    getPurchaseRecordInfo() {
      getPurchaseRecordInfo({
        cid: this.AdminId,
        orderId: this.$route.query.id
      }).then(res => {
        if (res.code == 0) {
          this.consumeOrderInfo = res.data.consumeOrderInfo
          this.packageLogInfo = res.data.packageLogInfo
        } else {
          this.$message.error(res.message)
        }
      })
    }
  },
  computed: {
    ...mapState({
      AdminId: state => state.AdminId,
      code: state => state.code

    }),
  },
}
</script>

<style scoped lang="scss">
.el-container {
  flex-direction: column;

  .footer-copyright {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
  }
}

.el-card {
  margin-top: 20px;
}

.consumeOrderInfo {
  line-height: 30px;

  i {
    font-size: 30px;
  }

  .el-icon-document-remove {
    color: #E6A23C;
  }

  .el-icon-document-checked {
    color: #67C23A;
  }

  .el-icon-circle-close {
    color: #F56C6C;
  }
}

.product_information {
  border: 1px solid #e5e9f2;

  .item {
    text-align: center;
  }

  .title {
    height: 40px;
    background: rgba(245, 248, 250, 1);
    padding-top: 15px;
  }

  .info {
    line-height: 60px;
  }
}
</style>